module.exports = __webpack_public_path__ + "img/crossStain.324b9d9a.jpg";